module.exports = __webpack_public_path__ + "static/img/信息3.c9523e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/信息3.png
// module id = b0wg
// module chunks = 1